import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditOrganization = (props) => {
  const [organization, setOrganization] = useState();

  const GetOrganization = (organization_id) => {
    AdminInterface.instance.getOrganization(organization_id).then((response) => {
      setOrganization(response.data);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response.data?.detail,
      });
    })
  }

  useEffect(() => {
    GetOrganization(props.organization_id);
  }, [props.organization_id]);

  const submitOrganizationUpdates = (organization) => {
    AdminInterface.instance.updateOrganization(props.organization_id, organization).then(() => {
      Swal.fire('Updated!', '', 'success')
      props.setListRequiresReload(true);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response.data?.detail,
      });
    })
  }

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardTitle>Edit Organization</CardTitle>
          </CardTitleWrap>
          <Form onSubmit={submitOrganizationUpdates} initialValues={organization}>
            {({ handleSubmit, form }) => (
              <FormContainer horizontal onSubmit={handleSubmit}>
                <FormGroup>
                  <FormGroupLabel>Name</FormGroupLabel>
                  <FormGroupField>
                    <Field name="name" component="input" type="text" placeholder="Name" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Display Name</FormGroupLabel>
                  <FormGroupField>
                    <Field name="display_name" component="input" type="text" placeholder="Display Name" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Logo URL</FormGroupLabel>
                  <FormGroupField>
                    <Field name="logo_url" component="input" placeholder="Logo URL" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Address</FormGroupLabel>
                  <FormGroupField>
                    <Field name="addressLine1" component="input" placeholder="Address" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Country</FormGroupLabel>
                  <FormGroupField>
                    <Field name="country" component="input" placeholder="e.g. Canada" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Province</FormGroupLabel>
                  <FormGroupField>
                    <Field name="province" component="input" placeholder="e.g. Manitoba" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>City</FormGroupLabel>
                  <FormGroupField>
                    <Field name="city" component="input" placeholder="e.g. Winnipeg" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Postal Code</FormGroupLabel>
                  <FormGroupField>
                    <Field name="postalCode" component="input" placeholder="e.g. K1A 0T6" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Domain</FormGroupLabel>
                  <FormGroupField>
                    <Field name="domain" component="input" placeholder="Domain" isRequired/>
                  </FormGroupField>
                </FormGroup>
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Submit</Button>
                  <Button variant="secondary" type="button" onClick={() => props.setEditOrganizationIdHandler(null)}>
                    Cancel
                  </Button>
                </FormButtonToolbar>
              </FormContainer>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EditOrganization;
